import React from 'react'
import {
    Flex,
    useStyleConfig,
    Text,
    Button,
    Img,
    useMediaQuery,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {ChefBigIcon, CutleryIcon, ChronoIcon, VerticalLineIcon} from '../../icons'
import {remCalc} from '../../../theme/_utils'
import VideoIframe from '../../video-iframe'
import {FormattedMessage} from 'react-intl'

export const RecipeHeroBanner = ({title, description, recipeInfo, mediaData}) => {
    const styles = useStyleConfig('RecipeHeroBanner')
    const isMediaVideo = mediaData?.content_type?.split('/')?.[0] !== 'image'
    const [isTablet] = useMediaQuery(`(max-width: ${remCalc(1023)})`)
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(329)})`)
    const handlePrint = async () => {
        window.print()
    }
    return (
        <Flex
            {...styles?.bannerContainer}
            layerStyle="page"
            data-testid="recipe-herobanner-container"
        >
            <Flex {...styles?.infoContainer}>
                <Flex {...styles?.recipeInfoContainer}>
                    <Text {...styles?.infoTitle}>{title}</Text>
                    <Text {...styles?.description}>{description}</Text>
                    <Flex {...styles?.buttonContainer}>
                        <Button onClick={() => handlePrint()} variant="secondary">
                            <FormattedMessage
                                id="recipes.details_page.hero_banner.print_button.text"
                                defaultMessage="Print this Recipe"
                            />
                        </Button>
                    </Flex>
                </Flex>
                <Flex justifyContent="center" w="100%">
                    <Flex {...styles?.infoBottomContainer}>
                        {recipeInfo?.classification?.complexity?.[0]?.title && (
                            <Flex {...styles?.infoTileContainer}>
                                <CutleryIcon {...styles?.infoIcons} />
                                <Flex {...styles?.infoTileTextContainer}>
                                    <Text {...styles?.infoTileTitle}>
                                        <FormattedMessage
                                            id="recipes.details_page.hero_banner.recipe_info.difficulty"
                                            defaultMessage="Difficulty"
                                        />
                                    </Text>
                                    <Text {...styles?.infoTileText}>
                                        {recipeInfo?.classification?.complexity?.[0]?.title}
                                    </Text>
                                </Flex>
                                {!isMobile && <VerticalLineIcon color="border.light" />}
                            </Flex>
                        )}
                        {recipeInfo?.time?.total_time && (
                            <Flex {...styles?.infoTileContainer}>
                                <ChronoIcon {...styles?.infoIcons} />
                                <Flex {...styles?.infoTileTextContainer}>
                                    <Text {...styles?.infoTileTitle}>
                                        <FormattedMessage
                                            id="recipes.details_page.hero_banner.recipe_info.time"
                                            defaultMessage="Time"
                                        />
                                    </Text>
                                    <Text {...styles?.infoTileText} minWidth={remCalc(50)}>
                                        {`${recipeInfo?.time?.total_time?.toString()} min`}
                                    </Text>
                                </Flex>
                                {!isTablet && <VerticalLineIcon color="border.light" />}
                            </Flex>
                        )}
                        {recipeInfo?.author && (
                            <Flex {...styles?.infoTileContainer}>
                                <ChefBigIcon {...styles?.infoIcons} />
                                <Flex {...styles?.infoTileTextContainer}>
                                    <Text {...styles?.infoTileTitle}>
                                        <FormattedMessage
                                            id="recipes.details_page.hero_banner.recipe_info.author"
                                            defaultMessage="Author"
                                        />
                                    </Text>
                                    <Text {...styles?.infoTileText}>{recipeInfo?.author}</Text>
                                </Flex>
                            </Flex>
                        )}
                    </Flex>
                </Flex>
            </Flex>
            <Flex {...styles?.mediaContainer}>
                {!isMediaVideo ? (
                    <Img w="100%" h="100%" objectFit="cover" src={mediaData?.url} />
                ) : (
                    <Flex w="100%" h="100%">
                        <VideoIframe title={title} videoSrc={mediaData?.url} />
                    </Flex>
                )}
            </Flex>
        </Flex>
    )
}

RecipeHeroBanner.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    mediaData: PropTypes.object,
    recipeInfo: PropTypes.object,
}
